




































































































































import { Component, Vue, Emit, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import moment from 'moment'
import SolicitacaoPendenciaStore from '@/components/SolicitacaoPendencia/Store/SolicitacaoPendenciaStore'
import { PendenciaMensagem, TipoMensagemEnum, TipoEnvioMensagemEnum, TipoDocumentoUpload }
  from '@/types/_'
import AgendamentoBackofficeStore from '@/components/AgendamentoBackoffice/Store/AgendamentoBackofficeStore'
import AgendamentoBackofficeAutorizacaoStore from '@/components/AgendamentoBackoffice/Store/AgendamentoBackofficeAutorizacaoStore'
import Theme from '@/styles/Theme'
import { maskHour, groupCollectionByField, timeoutDefault } from '@/utils/common'
import { Acoes } from '@/types/interfaces/AgendamentoCirurgia'

@Component

export default class ComponentModalSolicitacaoPendencia extends Vue {
  $refs: {
    chatScrollContent: HTMLElement
  }

  loadClose: boolean = false

  get loadingClose() {
    return this.loadClose
  }

  set loadingClose(value: boolean) {
    this.loadClose = value
  }

  mensagem: string = ''
  inputFiles: any[] = []
  msgLoader: boolean = false

  get msgLoading() {
    return this.msgLoader
  }

  set msgLoading(value: boolean) {
    this.msgLoader = value
  }

  get getMensagem() {
    return this.mensagem
  }

  set getMensagem(value: string) {
    this.mensagem = value
  }

  get getSolicitacaoPendenciaStore() {
    return getModule(SolicitacaoPendenciaStore, this.$store)
  }

  get getAgendamentoBackofficeStore() {
    return getModule(AgendamentoBackofficeStore, this.$store)
  }

  get getAutorizacaoStore() {
    return getModule(AgendamentoBackofficeAutorizacaoStore, this.$store)
  }

  get getRequestMessage() {
    return this.getAgendamentoBackofficeStore.requestMessage
  }

  get showModalPendencia() {
    const show = this.getSolicitacaoPendenciaStore.modalSolicitacaoPendencia.pendencia
    this.toggleBodyOverflow(show)
    return show
  }

  set showModalPendencia(value) {
    this.getSolicitacaoPendenciaStore.setModalSolicitacaoPendencia(value)
  }

  get getMensagens() {
    return this.getSolicitacaoPendenciaStore.pendencia.mensagens
  }

  get getAcessoHospital() {
    return this.getSolicitacaoPendenciaStore.acessoHospital
  }

  get getTheme() {
    return Theme
  }

  get getEncerrarPendenciaBtn() {
    return this.getSolicitacaoPendenciaStore.encerrarPendenciaBtn
  }

  get getTipoMensagemEnum() {
    return TipoMensagemEnum
  }

  formatHour(value: string) {
    return maskHour(value)
  }

  groupByDate(value: any) {
    return groupCollectionByField(value)
  }

  async inputFile(newFile, oldFile) {
    this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.post)
    if (newFile.identifier) {
      return
    }

    const form = new FormData()
    form.append('laudos', newFile.file)
    const time = moment().format('YYYY-MM-DDTHH:mm')

    const param: any = {
      hospitalId: this.getSolicitacaoPendenciaStore.agendamentoMedico.hospitalId,
      tipoDocumento: TipoDocumentoUpload.PendenciaHospital,
      formData: form,
    }

    const request = await this.getSolicitacaoPendenciaStore.uploadDocumento(param)

    if (request.success) {
      const result = request.data[0]
      const documentoId = result.id
      const { url } = result
      const { nomeArquivo } = result
      await this.addMensagemManager(documentoId, url, nomeArquivo, TipoMensagemEnum.Documento)
    }

    this.clearLoadingRequest()
  }

  async addmensagemEnter() {
    if (this.getMensagem) {
      await this.addMensagem()
    }
  }

  async addMensagem() {
    this.msgLoading = true
    await this.addMensagemManager(null, '', '', TipoMensagemEnum.Texto)
    this.msgLoading = false
  }

  async addMensagemManager(documentoId, url, nomeArquivo, tipoMensagem) {
    const time = moment().format('YYYY-MM-DDTHH:mm')
    const mensagemHospital = this.getAcessoHospital

    const pendenciaMensagem: PendenciaMensagem = {
      mensagemHospital,
      id: '',
      dataEnvio: time,
      tipoMensagem,
      texto: this.getMensagem,
      documentoId,
      url,
      nomeArquivo,
    }

    // Duplica mensagens...
    // this.getSolicitacaoPendenciaStore.setPendenciaMensagem(pendenciaMensagem)

    this.getMensagem = ''

    switch (this.getSolicitacaoPendenciaStore.tipoEnvioMensagem) {
      case TipoEnvioMensagemEnum.Abrir:
        this.getSolicitacaoPendenciaStore.setEnviarPendencia(true)
        break

      case TipoEnvioMensagemEnum.Enviar:
        await this.getSolicitacaoPendenciaStore.enviarMensagem(pendenciaMensagem)
        break

      default:
        break
    }
  }

  async encerrarPendencia() {
    const { solicitacaoId } = this.getSolicitacaoPendenciaStore.pendencia
    this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.init.text)
    const result = await this.getSolicitacaoPendenciaStore.encerrarPendencia()

    if (result) {
      this.getMensagem = ''
      this.getSolicitacaoPendenciaStore.setModalSolicitacaoPendencia(false)
      this.getSolicitacaoPendenciaStore.clearMensagem()
      this.getAgendamentoBackofficeStore.setShowModalTriagem(true)
      const { scrollY } = window
      await this.getAgendamentoBackofficeStore.setScrollY(scrollY)
      await this.getAgendamentoBackofficeStore.LoadSolicitacaoById(solicitacaoId)
      this.getSolicitacaoPendenciaStore.clearPendencia()
      this.openModalFlow(this.getAgendamentoBackofficeStore.acoes)
      this.clearLoadingRequest()
    }
  }

  async openModalFlow(acoes: Acoes) {
    if (acoes.autorizacaoFazAnalisePreCotacao || acoes.autorizacaoFazAnalisePreCotacao) {
      await this.showModalAutorizacao()
    } else if (acoes.autorizacaoFazCotacao) {
      await this.showModalAutorizacao()
    } else if (acoes.autorizacaoAutorizar) {
      await this.getAutorizacaoStore.setShowModalAutorizarProcesso(true)
    } else {
      await this.visualizar()
    }
  }

  async showModalAutorizacao() {
    this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.init.text)
    this.getAutorizacaoStore.setShowModalAutorizacao(true)
    this.clearLoadingRequest()
  }

  async visualizar() {
    this.getAutorizacaoStore.setDisabled(true)
    await this.getAgendamentoBackofficeStore.loadNovaDataAgendamentoSolicitacao(this.getAutorizacaoStore.solicitacao)
    this.getAutorizacaoStore.setShowModalAutorizacao(true)
  }

  scrollToMensagem() {
    if (this.$refs.chatScrollContent) {
      setTimeout(() => {
        const elem = this.$refs.chatScrollContent

        const option: ScrollToOptions = {
          behavior: 'smooth',
          left: 0,
          top: elem.scrollHeight,
        }
        elem.scrollTo(option)
      }, 0)
    }
  }

  @Watch('showModalPendencia')
  onChangeShowModalPendencia() {
    this.scrollToMensagem()
  }


  toggleBodyOverflow(isOpen: Boolean) {
    const html = document.querySelector('html')
    const noOverflowClass = 'modal-is-open'

    if (html !== null) {
      html.classList.remove(noOverflowClass)
      if (isOpen) {
        html.classList.toggle(noOverflowClass)
      }
    }
  }

  @Emit('setLoadingRequest')
  setLoadingRequest(status, text) { }

  @Emit('clearLoadingRequest')
  clearLoadingRequest() { }


  async closeModalPendencia() {
    this.loadingClose = true
    this.getMensagem = ''
    this.getSolicitacaoPendenciaStore.setModalSolicitacaoPendencia(false)

    if (this.getSolicitacaoPendenciaStore.tipoEnvioMensagem === TipoEnvioMensagemEnum.Enviar) {
      this.getSolicitacaoPendenciaStore.clearMensagem()
    }

    if (this.getSolicitacaoPendenciaStore.encerrarPendenciaBtn) {
      const { solicitacaoId } = this.getSolicitacaoPendenciaStore.pendencia
      this.getAgendamentoBackofficeStore.desbloquearAgendamento(solicitacaoId)
    }

    await timeoutDefault()

    this.getSolicitacaoPendenciaStore.setVisualizarPendencia(false)
    this.loadingClose = false
  }
}
